import React from "react";
import { Modal, Button, Card } from "react-bootstrap";

const ServiceTemplateModal = ({
  show,
  onHide,
  templates,
  onSelectTemplate,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Pilih Template Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "grid", gap: "16px" }}>
          {templates && templates.length > 0 ? (
            templates.map((template) => (
              <Card
                key={template.id}
                style={{
                  cursor: "pointer",
                  border: "1px solid #e5e7eb",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.boxShadow =
                    "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.boxShadow = "none";
                }}
                onClick={() => onSelectTemplate(template)}
              >
                <Card.Body>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <h5 style={{ margin: "0 0 8px 0", color: "#1f2937" }}>
                        {template.name}
                      </h5>
                      <p
                        style={{
                          margin: "0",
                          color: "#6b7280",
                          fontSize: "14px",
                        }}
                      >
                        {template.description}
                      </p>
                      <div style={{ marginTop: "12px" }}>
                        <small style={{ color: "#6b7280" }}>
                          Items:{" "}
                          {template.template_items
                            ?.map(
                              (item) =>
                                `${item.item_name} (${item.quantity} ${item.unit})`
                            )
                            .join(", ") || "No items"}
                        </small>
                      </div>
                    </div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectTemplate(template);
                      }}
                    >
                      Pilih Template
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            ))
          ) : (
            <div
              style={{ textAlign: "center", padding: "40px", color: "#6b7280" }}
            >
              <p>Tidak ada template service tersedia</p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ServiceTemplateModal;
